module.exports = __webpack_public_path__ + "img/print-title.3634a210.png";